import {GeneriskAction, GeneriskModel, toggleSelectedFylkeAction, updateSelectedKommuneAction} from "../GeneriskeRapporter/update";
import React from "react";
import tw from "twin.macro";
import ContractAreaSelect from "./ContractAreaSelect";
import FylkeSelect from "@nvdb-rapport/shared/src/components/AreaSelect/FylkeMultiNew";
import KommuneSelect from "@nvdb-rapport/shared/src/components/AreaSelect/KommuneSelectNew";
import Vegfilter from "@nvdb-rapport/shared/src/components/Vegfilter";
import {SharedDatePicker} from "@nvdb-rapport/shared/src/components/DatePicker";

interface SearchCriteriaProps {
  generiskState: GeneriskModel;
  generiskDispatch: React.Dispatch<GeneriskAction>;
  formIsValid: boolean;
}

export default function SearchCriteria({
  generiskState,
  generiskDispatch,
  formIsValid
}: SearchCriteriaProps){
  if (generiskState.selectedReportType.isNothing()) {
    return null;
  }

  return (
    <>
      <h3 style={tw`text-xl font-bold text-left m-0 w-full`}>Søkekriterier</h3>
      <ContractAreaSelect
        contractAreas={generiskState.contractAreas}
        selectContractArea={payload =>
          generiskDispatch({ type: "SelectContractArea", payload })
        }
        isRequired={false}
      />
      <FylkeSelect
        selectedFylker={generiskState.selectedFylker}
        variant="standard"
        omraader={generiskState.omraader}
        updateSelectedFylker={fylke =>
          generiskDispatch(toggleSelectedFylkeAction(fylke))
        }
      />
      <KommuneSelect
        language="nb_NO"
        variant="standard"
        omraader={generiskState.omraader}
        selectedFylker={generiskState.selectedFylker}
        selectedKommuner={generiskState.selectedKommuner}
        setSelectedKommuner={kommuner =>
          generiskDispatch(updateSelectedKommuneAction(kommuner))
        }
      />

      <Vegfilter
        vegsystemInput={generiskState.vegsystemInput}
        vegsystem={generiskState.vegsystem}
        updateVegsystem={vegsystem =>
          generiskDispatch({
            type: "UpdateVegsystem",
            payload: vegsystem,
          })
        }
      />

      <SharedDatePicker
        selectDate={date => {
          generiskDispatch({
            type: "SetDate",
            payload: date,
          })
        }}
        currentDate={generiskState.date}
        language={"nb_NO"}
        variant={"standard"}
      />

      <p
        style={{
          ...tw`leading-loose text-sm`,
          color:
            generiskState.showValidationErrors && !formIsValid
              ? "red"
              : "inherit",
        }}
      >
        For å kunne gjennomføre et søk må du velge minst{" "}
        <span style={tw`font-bold`}>et kontraktsområde</span>,{" "}
        <span style={tw`font-bold`}>et fylke</span> eller{" "}
        <span style={tw`font-bold`}>én kommune</span>.
      </p>
    </>
  )
}